// "How credits are used" reference table shown on the Billing page.
// Sourced from the Listen2It credit rate card (Prasanna's pricing sheet — Config/Feature rate
// card tabs): 1 credit = 1 word for TTS; every other feature's rate is CEILING(vendor_cost /
// (reference_revenue_per_credit * target_cost_ratio), credit_rounding_step), anchored to the
// Full/Team plan. These are the live "Credits per unit" figures, not placeholders.
export const CREDIT_RATES = [
  { label: 'Text to speech', cost: '1 credit', unit: 'per word generated' },
  { label: 'Dubbing', cost: '1,200 credits', unit: 'per min of output audio' },
  { label: 'Voice cloning', cost: '100 credits', unit: 'per job' },
  { label: 'Voice design', cost: '100 credits', unit: 'per job' },
  { label: 'Voice mixing', cost: '400 credits', unit: 'per job' },
  { label: 'Voice changer', cost: '500 credits', unit: 'per min of output audio' },
  { label: 'Voice isolator', cost: '350 credits', unit: 'per min of input audio' },
];
